import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {NotificationsService, SimpleNotificationsModule} from 'angular2-notifications';
import {VideoManageComponent} from './video-manage/video-manage.component';
import {VideoManageService} from './video-manage/video-manage.service';
import {BootstrapModalModule} from 'ngx-modialog/plugins/bootstrap';
import {Ng2CompleterModule} from 'ng2-completer';
import {BsDatepickerModule, TooltipModule} from 'ngx-bootstrap';
import {VideoTitlesComponent} from './video-search/video-titles.component';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {VideoTitlesService} from './video-search/video-titles.service';
import {ChartsModule} from 'ng2-charts';
import {InfohashService} from '../catalogue/infohash/infohash.service';
import {ImageUpdateService} from '../catalogue/image-update/image-update.service';
import {VideoResultsComponent} from './video-results/video-results.component';
import {QAService} from '../catalogue/qa/qa.service';
import {TitleRequestsService} from '../catalogue/title-requests/title-requests.service';
import {SchedulingService} from '../catalogue/scheduling/scheduling.service';
import {DiscoveryService} from '../catalogue/discovery/discovery.service';
import {VideoBusyIndicatorComponent} from './video-loading/video-busy-indicator.component';
import {DatePipe} from '@angular/common';
import {ClipboardService} from 'ngx-clipboard';
import {TalentVideoSearchComponent} from './talent-video-search/talent-video-search.component';
import {TalentVideoResultsComponent} from './talent-video-results/talent-video-results.component';
import {TalentVideoManageComponent} from './talent-video-manage/talent-video-manage.component';


@NgModule({
    declarations: [
        VideoTitlesComponent, VideoManageComponent, VideoBusyIndicatorComponent,
        VideoResultsComponent, TalentVideoSearchComponent, TalentVideoResultsComponent, TalentVideoManageComponent],
    exports: [VideoTitlesComponent, VideoBusyIndicatorComponent, TalentVideoSearchComponent, TalentVideoResultsComponent, TalentVideoManageComponent],
    imports: [BrowserModule,
        HttpModule,
        FormsModule,
        SharedModule,
        SimpleNotificationsModule.forRoot(),
        BootstrapModalModule,
        Ng2CompleterModule,
        BsDatepickerModule.forRoot(),
        CollapseModule.forRoot(),
        TooltipModule.forRoot(), ChartsModule],
    providers: [
        VideoManageService, DatePipe, NotificationsService,
        ClipboardService,
        InfohashService,
        ImageUpdateService,
        VideoTitlesService,
        QAService, TitleRequestsService,
        SchedulingService,
        DiscoveryService]
})
export class VideoModule {
}



// WEBPACK FOOTER //
// ./src/app/youtube-video/video.module.ts